import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Componente para proteger rutas basándose en el rol del usuario
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componente a renderizar si el usuario tiene acceso
 * @param {string[]} props.allowedRoles - Roles permitidos para acceder a esta ruta
 * @param {string} props.redirectTo - Ruta a la que redirigir si no tiene acceso (default: '/reservas' para AGENCY, '/' para otros)
 */
const RoleBasedRoute = ({ children, allowedRoles = [], redirectTo = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  // Si no hay usuario, ya ProtectedRoute se encarga de redirigir al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si no se especifican roles permitidos, permitir acceso a todos
  if (allowedRoles.length === 0) {
    return children;
  }

  // Verificar si el usuario tiene un rol permitido
  const hasAccess = allowedRoles.includes(user.role);

  if (!hasAccess) {
    // Si el usuario es AGENCY, redirigir a reservas
    // Si es otro rol sin acceso, redirigir a home
    const defaultRedirect = user.role === 'AGENCY' ? '/reservas' : '/';
    return <Navigate to={redirectTo || defaultRedirect} replace />;
  }

  return children;
};

export default RoleBasedRoute;



